import { makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Button, Modal } from 'components/Base';
import Fields from 'components/Fields';
import Icons from 'components/Icons';
import React, { useEffect, useState } from 'react';
import CustomerRow from './components/CustomerRow';
import { Formik, FormikProps } from 'formik';
import { Typography } from '@material-ui/core';
import { ClientRequest } from 'api/resources/inteliflo';
import api from 'api';
import { AxiosResponse } from 'axios';
import Tabs from 'components/Tabs/Tabs';
import { errHelper } from 'utils';
import LoaderSpinner from 'components/LoaderSpinner/LoaderSpinner';

const useStyles = makeStyles({
  container: {
    width: '700px',
    overflow: 'auto',
    position: 'relative',
    transition: 'all 0.3s ease-in-out'
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginLeft: '36px',
    marginRight: '36px',
    marginTop: '24px'
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '24px'
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: '24px',
    right: '24px'
  },
  titleRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  listRow: {
    width: 'calc(100% - 58px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginLeft: '24px',
    marginRight: '24px'
  },
  column: {
    fontWeight: 'bold',
    color: '#004258'
  },
  addedColumn: {
    width: '318px',
    height: '56px',
    fontWeight: 700,
    color: '#2F2F2F'
  },
  delColumn: {
    width: '318px',
    height: '56px',
    fontWeight: 700,
    color: '#2F2F2F',
    textAlign: 'right',
    cursor: 'pointer'
  },
  inputContainer: {
    borderBottom: '2px solid #004258',
    width: 'calc(50% - 8px)',
    marginBottom: '12px'
  },
  noResults: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#999999',
    textAlign: 'center'
  },
  spinner: {
    paddingTop: '36px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
});

interface IntelliofloCustomerImportProps {
  isModalOpen: boolean;
  onClose: Function;
  importFunction: Function;
}

export interface IoCustomerType {
  id: number;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  full_name: string;
  isImportClientActionTriggered: Function;
}

const IntelliofloCustomerImport = ({
  isModalOpen,
  onClose,
  importFunction
}: IntelliofloCustomerImportProps) => {
  const classes = useStyles();
  const [customers, setCustomers] = useState([] as IoCustomerType[]);
  const [selectedCustomers, setSelectedCustomers] = useState(
    [] as IoCustomerType[]
  );
  const [caseCustomers, setCaseCustomers] = useState([] as IoCustomerType[]);
  const [firstName, setFirstName] = useState('');
  const [surname, setSurname] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [iOCustomerId, setiOCustomerId] = useState('');
  const [corporateName, setCorporateName] = useState('');
  const [trustName, setTrustName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [clearForm, setClearForm] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSearchFirstName = (e: any) => {
    setFirstName(e);
  };
  const onSearchSurname = (e: any) => {
    setSurname(e);
  };

  const onSearchCorporateName = (e: any) => {
    setCorporateName(e);
  };

  const onSearchTrustName = (e: any) => {
    setTrustName(e);
  };

  const selectCustomer = (customer: any) => {
    const selected = [...selectedCustomers, customer];
    setSelectedCustomers(selected as any);
  };

  const removeCustomer = (customer: any) => {
    const custs = selectedCustomers.filter(
      (cust: any) => cust.id !== customer.id
    );
    setSelectedCustomers(custs);
  };

  const addCaseCustomers = () => {
    setCaseCustomers([...caseCustomers, ...selectedCustomers]);
    setSelectedCustomers([]);
    setCustomers([]);
  };

  const removeCaseCUstomer = (customer: any) => {
    const caseCusts = caseCustomers.filter(
      (cust: any) => cust.id !== customer.id
    );
    setCaseCustomers(caseCusts);
  };

  const onDateFilter = (date: any) => {
    setDateOfBirth(date.format('YYYY-MM-DD'));
  };

  const IOIdFilter = (id: string) => {
    setiOCustomerId(id);
  };

  const clearAll = () => {
    setCustomers([]);
    setSelectedCustomers([]);
    setCaseCustomers([]);
  };

  const resetSearch = () => {
    setClearForm(true);
    setFirstName('');
    setSurname('');
    setDateOfBirth('');
    setiOCustomerId('');
    setCorporateName('');
    setTrustName('');
    setTimeout(() => {
      setClearForm(false);
    }, 500);
  };

  useEffect(() => {
    resetSearch();
  }, [selectedIndex]);

  const setIndexAndClear = (i: number) => {
    setSelectedIndex(i);
    setCustomers([]);
  };

  useEffect(() => {
    if (
      firstName.length !== 0 ||
      surname.length !== 0 ||
      dateOfBirth.length !== 0 ||
      iOCustomerId.length !== 0 ||
      trustName.length !== 0 ||
      corporateName.length !== 0
    ) {
      const requestObject = {} as ClientRequest;

      if (firstName.length !== 0) requestObject.first_name = firstName;
      if (surname.length !== 0) requestObject.last_name = surname;
      if (dateOfBirth.length !== 0) requestObject.date_of_birth = dateOfBirth;
      if (iOCustomerId.length !== 0)
        requestObject.external_reference = iOCustomerId;
      if (trustName.length !== 0) requestObject.trust_name = trustName;
      if (corporateName.length !== 0)
        requestObject.corporate_name = corporateName;

      setIsLoading(true);

      api.intelifloApi
        .importClients(requestObject)
        .then((response: AxiosResponse) => {
          const clients = response.data;
          setCustomers(clients as IoCustomerType[]);
          setIsLoading(false);
        })
        .catch(err => {
          setIsLoading(false);
          errHelper(err);
        });
    }
  }, [firstName, surname, dateOfBirth, iOCustomerId, trustName, corporateName]);

  return (
    <Formik
      initialValues={{
        firstname: '',
        surname: '',
        date_of_birth: null
      }}
      onSubmit={({ resetForm }) => {
        importFunction(
          caseCustomers.map((customer: any) => {
            return {
              first_name: customer.first_name,
              last_name: customer.last_name,
              intelligent_office_id: customer.id
            };
          })
        );
        onClose();
        clearAll();
        resetForm();
      }}
    >
      {({ handleSubmit, resetForm }: FormikProps<any>) => {
        return (
          <Modal
            isOpen={isModalOpen}
            closeModalFunc={() => {
              clearAll();
              onClose();
            }}
          >
            <BoxWrapper
              closeModal={() => {
                clearAll();
                onClose();
              }}
              title="Search Client(s) in Intelliflo"
              className={classes.container}
              style={{
                height: 'max-content',
                minHeight: '250px',
                paddingBottom: '74px'
              }}
            >
              {caseCustomers.length > 0 && (
                <div style={{ marginTop: '24px' }}>
                  {caseCustomers.map((customer: any, i: number) => {
                    return (
                      <div
                        className={classes.listRow}
                        key={`${customer.name}_${i}`}
                      >
                        <div className={classes.addedColumn}>
                          {customer.full_name}
                        </div>
                        <div className={classes.addedColumn}>
                          {customer.external_reference}
                        </div>
                        <div className={classes.delColumn}>
                          <Icons.DeleteIcon
                            style={{ color: 'yellow' }}
                            onClick={() => removeCaseCUstomer(customer)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              <form>
                <Tabs
                  options={['Indvidual(s)', 'Corporate', 'Trust']}
                  selectedIndex={selectedIndex}
                  setSelectedIndex={setIndexAndClear}
                />
                {caseCustomers.length !== 2 && (
                  <div className={classes.searchContainer}>
                    {selectedIndex === 0 ? (
                      <>
                        <div className={classes.inputContainer}>
                          <Fields.v2.Search
                            label="First name"
                            onSearch={(e: any) => onSearchFirstName(e)}
                            background="#F2F2F2"
                            name="firstname"
                            onClear={() => setClearForm(true)}
                            shouldClear={clearForm}
                          />
                        </div>
                        <div className={classes.inputContainer}>
                          <Fields.v2.Search
                            label="Surname"
                            onSearch={(e: any) => onSearchSurname(e)}
                            background="#F2F2F2"
                            name="surname"
                            onClear={() => setClearForm(true)}
                            shouldClear={clearForm}
                          />
                        </div>
                        <div className={classes.inputContainer}>
                          <Fields.v2.DateSelector
                            disabled={customers.length === 0}
                            label="Date of Birth"
                            onSelect={onDateFilter}
                            shouldClear={clearForm}
                          />
                        </div>
                      </>
                    ) : selectedIndex === 1 ? (
                      <div className={classes.inputContainer}>
                        <Fields.v2.Search
                          label="Corporate Name"
                          onSearch={(e: any) => onSearchCorporateName(e)}
                          background="#F2F2F2"
                          name="corporateName"
                          onClear={() => setClearForm(true)}
                          shouldClear={clearForm}
                        />
                      </div>
                    ) : (
                      <div className={classes.inputContainer}>
                        <Fields.v2.Search
                          label="Trust name"
                          onSearch={(e: any) => onSearchTrustName(e)}
                          background="#F2F2F2"
                          name="trustName"
                          onClear={() => setClearForm(true)}
                          shouldClear={clearForm}
                        />
                      </div>
                    )}
                    <div className={classes.inputContainer}>
                      <Fields.v2.Search
                        label="Search Cilent by ID"
                        onSearch={IOIdFilter}
                        background="#F2F2F2"
                        name="io_customer_id"
                        onClear={() => setClearForm(true)}
                        shouldClear={clearForm}
                      />
                    </div>
                  </div>
                )}
                <div
                  style={{
                    overflow: 'auto',
                    maxHeight: '214px',
                    position: 'relative',
                    paddingBottom: '26px',
                    paddingTop: '26px'
                  }}
                >
                  {customers.length > 0 &&
                    (selectedIndex === 0 ? (
                      <div className={classes.titleRow}>
                        <div
                          className={classes.column}
                          style={{ width: '20%' }}
                        ></div>
                        <div
                          className={classes.column}
                          style={{ width: '20%' }}
                        >
                          First Name
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '20%' }}
                        >
                          Surname
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '20%' }}
                        >
                          Date of Birth
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '20%' }}
                        >
                          Intelliflo ID
                        </div>
                      </div>
                    ) : selectedIndex === 1 ? (
                      <div className={classes.titleRow}>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        ></div>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        >
                          Company Name
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        >
                          Company Type
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        >
                          Intelliflo ID
                        </div>
                      </div>
                    ) : (
                      <div className={classes.titleRow}>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        ></div>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        >
                          Trust Name
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        >
                          Company Type
                        </div>
                        <div
                          className={classes.column}
                          style={{ width: '25%' }}
                        >
                          Intelliflo ID
                        </div>
                      </div>
                    ))}

                  {customers.length > 0 && !isLoading ? (
                    customers.map((customer: any, i: number) => {
                      return (
                        <CustomerRow
                          selectedIndex={selectedIndex}
                          key={`cust_4${i}}`}
                          customer={customer}
                          selectCustomer={selectCustomer}
                          removeCustomer={removeCustomer}
                          caseCustomers={caseCustomers}
                          selectedCustomers={selectedCustomers}
                          index={i}
                        />
                      );
                    })
                  ) : isLoading ? (
                    <div>
                      <LoaderSpinner isLoading={isLoading} />
                    </div>
                  ) : (
                    <Typography className={classes.noResults} variant="h3">
                      NO RESULTS
                    </Typography>
                  )}
                </div>
                <div className={classes.buttonContainer}>
                  {caseCustomers.length > 0 && (
                    <div
                      style={{
                        marginRight: caseCustomers.length !== 2 ? '24px' : '0px'
                      }}
                    >
                      <Button key="import" onClick={() => handleSubmit()}>
                        {caseCustomers.length === 1
                          ? 'Import Client'
                          : 'Import Clients'}
                      </Button>
                    </div>
                  )}
                  {caseCustomers.length !== 2 && (
                    <Button
                      key="add"
                      onClick={() => {
                        addCaseCustomers();
                        resetForm({
                          values: {
                            firstname: '',
                            surname: '',
                            date_of_birth: null
                          }
                        });
                        localStorage.clear();
                        resetSearch();
                      }}
                    >
                      {selectedCustomers.length > 1
                        ? 'Add Clients'
                        : 'Add Client'}
                    </Button>
                  )}
                </div>
              </form>
            </BoxWrapper>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default IntelliofloCustomerImport;
